<template>
  <div class="input-search-wrapper">
    <img class="search-icon" src="@/assets/icon/search-icon.svg" />
    <input :placeholder="placeholder" v-model="keyword" />
  </div>
</template>

<script>
export default {
  props: ['placeholder', 'value'],
  data() {
    return {
      keyword: ''
    };
  },
  watch: {
    value() {
      if (this.value !== this.keyword) {
        this.keyword = this.value;
      }
    },
    keyword() {
      this.$emit('input', this.keyword);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.input-search-wrapper {
  position: relative;
  width: fit-content;
  .search-icon {
    position: absolute;
    top: 12px;
    bottom: 12px;
    right: 12px;
    left: 16px;
  }
  input {
    border: 1px solid #f3f5fa;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 8px 8px 8px 40px;
    color: #000;
    &::placeholder {
      color: $secondary-color;
    }
  }
}
</style>
